export default {"src":"/pro/_next/static/media/snx.6eb8e5df.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};